module.exports = __webpack_public_path__ + "img/t1-13.aeb0c519.png";